module.exports = __webpack_public_path__ + "static/img3-4ecc2cc1d855b0585d2806a0cc49aa1c.png";